<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar :back_path="back_path || '/activity'" :navbar_sub_visible="$device != 'mobile'" active_screen="เอกสาร" :content_title="ticket_data.title" :hide_search="true" />
        <div :class="`'ml-20 mr-20 mb-20 mt-20 main-content is-${$device}`">
            <!-- <div class="row justify-content-center">
                <span class="fs-20 black fw-600" style="display: block"> {{ $t('เอกสาร') }} </span>
            </div> -->
            <div class="row justify-content-center">
                <span class="fs-20 black fw-600 red" style="display: block"> {{ ticket_data.title }} </span>
            </div>
            <div class="custom-container">
                <div v-for="(column, columnIndex) in columns" :key="columnIndex" class="custom-col">
                    <div v-for="(item, itemIndex) in column" :key="itemIndex" class="custom-item-container" :style="{ backgroundColor: item.active ? '#f4f4f4' : '#fcfcfc', cursor: 'pointer' }" @click="goToDocDetail(item)">
                        <i class="fa fa-file-text-o" aria-hidden="true" style="font-size: 72px; margin-bottom: 14px"></i>
                        <br />
                        <span class="fs-16 black fw-600"> {{ item.label }}</span>
                        <br />
                        <span class="fs-16" :style="{ color: item.active ? 'red' : 'green' }">{{ $t('อ่านแล้ว') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import moment from 'moment';
import navbar from '../../components/navbar';
import _ from 'lodash';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            activity_detail: {
                // title: 'คอนเสริต์มหัศจรรย์ รักไม่รู้จบ',
            },
            getting_data: false,
            back_path: this.$route.query.back_path,
            pdfUrl: 'https://www.orimi.com/pdf-test.pdf',
            act_id: this.$route.query.act_id,
            items: [
                // {
                //     label: 'กำหนดการกิจกรรม.pdf',
                //     pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/dGs6o1652196187.pdf',
                // },
                // {
                //     label: 'แบบฟอร์มผลตรวจ ATK.pdf',
                //     pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/ZAOYD1652196187.pdf',
                // },
                // {
                //     label: 'แผนที่เอสซีจี.pdf',
                //     pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/yUQ3R1652196187.pdf',
                // },
                // {
                //     label: 'แบบฟอร์มผลตรวจ ATK.pdf',
                //     pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/yUQ3R1652196187.pdf',
                // },
            ],
            apply_id: this.$route.query.apply_id,
            ticket_data: {
                // apply_id: 50236,
                // act_id: 659,
                // image_full: 'https://apigwd.scg.com/DebentureClubDev/images/activity/2I6K61649051975.jpg',
                // image: 'https://apigwd.scg.com/DebentureClubDev/images/activity_resize/2I6K61649051975.jpg',
                // title: 'SCG Smiling : แผ่นภาพ คิด Learn',
                // act_day: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30-11.30 น.',
                // confirm_phone_date: null,
                // confirm_mail_date: 1654016400,
                // confirm_sms_date: 1654016400,
                // code: 'SCG087620',
                // date: 1649992609,
                // group_receive: {
                //     group_id: 768,
                //     title: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //     display_order: 1,
                //     start_date: 1653098400,
                //     end_date: 1653107400,
                // },
                // group_choose1: {
                //     group_id: 768,
                //     title: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //     display_order: 1,
                //     start_date: 1653098400,
                //     end_date: 1653107400,
                // },
                // group_choose2: null,
                // group_choose3: null,
                // atype_name: 'เวิร์คชอป',
                // confirm_flag: 0,
                // status: 'รอเข้าร่วม',
                // button_cancel: true,
                // button_confirm: false,
                // button_form: false,
                // attach_file_pid: true,
                // attach_file_passport: false,
                // attach_file_payment: true,
                // accom_form: true,
                // member_form: true,
                // accom: [],
                // ticket_data: {
                //     main_pdf: 'https://apigwd.scg.com/DebentureClubDev/files/activity/KL3Vj1651225662.pdf',
                //     label_doc_btn: 'เอกสาร',
                //     display_doc_btn: true,
                //     label_ticket_btn: 'ตั๋วอิเล็กทรอนิกส์',
                //     display_ticket_btn: true,
                //     label_attach_btn: 'แนบเอกสาร',
                //     display_attach_btn: true,
                //     doc_list: [
                //         {
                //             label: 'กำหนดการกิจกรรม.pdf',
                //             pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/dGs6o1652196187.pdf',
                //         },
                //         {
                //             label: 'แบบฟอร์มผลตรวจ ATK.pdf',
                //             pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/ZAOYD1652196187.pdf',
                //         },
                //         {
                //             label: 'แผนที่เอสซีจี.pdf',
                //             pdf_url: 'https://apigwd.scg.com/DebentureClubDev/files/activity/doc/yUQ3R1652196187.pdf',
                //         },
                //     ],
                //     ticket_list: [
                //         {
                //             ticket_id: 16,
                //             no: 'ตั๋วใบที่ 1',
                //             ticket_no: 'WS221A1A2A3A4A5',
                //             group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //             start_at: 1653098400,
                //             end_at: 1653107400,
                //             ticket_template: '2',
                //             ticket_bg: '#ffebcd',
                //             ticket_font_color: '#006633',
                //             ticket_header_bg: '#cc3333',
                //             ticket_header_font_color: '#ffffff',
                //             ticket_body_bg: null,
                //             ticket_body_font_color: '#191970',
                //             active: false,
                //             active_txt: 'ใช้งานแล้ว',
                //             qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/activity/disable-qrcode.jpg',
                //             pin: '7400',
                //             share: 'https://debentureclub-dev.scg.com/share/ticket/c74d97b01eae257e44aa9d5bade97baf',
                //             location_line1: 'สถานที่',
                //             location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                //             label1: 'ลงทะเบียน',
                //             value1: 'A1',
                //             label2: 'แถวที่นั่ง',
                //             value2: 'A2',
                //             label3: 'เลขที่นั่ง',
                //             value3: 'A3',
                //             label4: 'label4',
                //             value4: 'A4',
                //             label5: 'label5',
                //             value5: 'A5',
                //             doc: [
                //                 {
                //                     attach_label_id: 6,
                //                     label: 'ผลตรวจ ATK',
                //                     display_upload_btn: true,
                //                     status_upload: false,
                //                     file: null,
                //                 },
                //                 {
                //                     attach_label_id: 11,
                //                     label: 'ประวัติการรับวัคซีนโควิด-19',
                //                     display_upload_btn: true,
                //                     status_upload: true,
                //                     file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/uWgZX1652171907.jpg',
                //                 },
                //             ],
                //             condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                //         },
                //         {
                //             ticket_id: 17,
                //             no: 'ตั๋วใบที่ 2',
                //             ticket_no: 'WS221A0A2A3A4A5',
                //             group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //             start_at: 1653098400,
                //             end_at: 1653107400,
                //             ticket_template: '2',
                //             ticket_bg: '#ffebcd',
                //             ticket_font_color: '#006633',
                //             ticket_header_bg: '#cc3333',
                //             ticket_header_font_color: '#ffffff',
                //             ticket_body_bg: null,
                //             ticket_body_font_color: '#191970',
                //             active: true,
                //             active_txt: 'ยังไม่ได้ใช้งาน',
                //             qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/70efdf2ec9b086079795c442636b55fb.png',
                //             pin: '7400',
                //             share: 'https://debentureclub-dev.scg.com/share/ticket/70efdf2ec9b086079795c442636b55fb',
                //             location_line1: 'สถานที่',
                //             location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                //             label1: 'ลงทะเบียน',
                //             value1: 'A0',
                //             label2: 'แถวที่นั่ง',
                //             value2: 'A2',
                //             label3: 'เลขที่นั่ง',
                //             value3: 'A3',
                //             label4: 'label4',
                //             value4: 'A4',
                //             label5: 'label5',
                //             value5: 'A5',
                //             doc: [
                //                 {
                //                     attach_label_id: 6,
                //                     label: 'ผลตรวจ ATK',
                //                     display_upload_btn: true,
                //                     status_upload: true,
                //                     file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/t4cZR1652106106.jpg',
                //                 },
                //                 {
                //                     attach_label_id: 11,
                //                     label: 'ประวัติการรับวัคซีนโควิด-19',
                //                     display_upload_btn: true,
                //                     status_upload: false,
                //                     file: null,
                //                 },
                //             ],
                //             condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                //         },
                //         {
                //             ticket_id: 18,
                //             no: 'ตั๋วใบที่ 3',
                //             ticket_no: 'WS221A2A2A3A4A5',
                //             group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //             start_at: 1653098400,
                //             end_at: 1653107400,
                //             ticket_template: '2',
                //             ticket_bg: '#ffebcd',
                //             ticket_font_color: '#006633',
                //             ticket_header_bg: '#cc3333',
                //             ticket_header_font_color: '#ffffff',
                //             ticket_body_bg: null,
                //             ticket_body_font_color: '#191970',
                //             active: true,
                //             active_txt: 'ยังไม่ได้ใช้งาน',
                //             qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/6f4922f45568161a8cdf4ad2299f6d23.png',
                //             pin: '7400',
                //             share: 'https://debentureclub-dev.scg.com/share/ticket/6f4922f45568161a8cdf4ad2299f6d23',
                //             location_line1: 'สถานที่',
                //             location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                //             label1: 'ลงทะเบียน',
                //             value1: 'A2',
                //             label2: 'แถวที่นั่ง',
                //             value2: 'A2',
                //             label3: 'เลขที่นั่ง',
                //             value3: 'A3',
                //             label4: 'label4',
                //             value4: 'A4',
                //             label5: 'label5',
                //             value5: 'A5',
                //             doc: [
                //                 {
                //                     attach_label_id: 6,
                //                     label: 'ผลตรวจ ATK',
                //                     display_upload_btn: true,
                //                     status_upload: false,
                //                     file: null,
                //                 },
                //                 {
                //                     attach_label_id: 11,
                //                     label: 'ประวัติการรับวัคซีนโควิด-19',
                //                     display_upload_btn: true,
                //                     status_upload: false,
                //                     file: null,
                //                 },
                //             ],
                //             condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                //         },
                //         {
                //             ticket_id: 40,
                //             no: 'ตั๋วใบที่ 4',
                //             ticket_no: 'WS2211001',
                //             group_name: 'วันเสาร์ที่ 21 พฤษภาคม 2565 เวลา 08.30 - 11.30 น.',
                //             start_at: 1653098400,
                //             end_at: 1653107400,
                //             ticket_template: '2',
                //             ticket_bg: '#ffebcd',
                //             ticket_font_color: '#006633',
                //             ticket_header_bg: '#cc3333',
                //             ticket_header_font_color: '#ffffff',
                //             ticket_body_bg: null,
                //             ticket_body_font_color: '#191970',
                //             active: true,
                //             active_txt: 'ยังไม่ได้ใช้งาน',
                //             qrcode: 'https://apigwd.scg.com/DebentureClubDev/images/ticket-qrcode/d645920e395fedad7bbbed0eca3fe2e0.png',
                //             pin: '7400',
                //             share: 'https://debentureclub-dev.scg.com/share/ticket/d645920e395fedad7bbbed0eca3fe2e0',
                //             location_line1: 'สถานที่',
                //             location_line2: 'ห้องแกรนด์ฮอลล์ ชั้น 10  อาคารอเนกประสงค์  เอสซีจี บางซื่อ',
                //             label1: 'ลงทะเบียน',
                //             value1: '08.00 – 09.00 น.',
                //             label2: 'แถวที่นั่ง',
                //             value2: '1',
                //             label3: 'เลขที่นั่ง',
                //             value3: '001',
                //             label4: '',
                //             value4: '',
                //             label5: '',
                //             value5: '',
                //             doc: [
                //                 {
                //                     attach_label_id: 6,
                //                     label: 'ผลตรวจ ATK',
                //                     display_upload_btn: true,
                //                     status_upload: true,
                //                     file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/Hei141652166645.jpg',
                //                 },
                //                 {
                //                     attach_label_id: 11,
                //                     label: 'ประวัติการรับวัคซีนโควิด-19',
                //                     display_upload_btn: true,
                //                     status_upload: true,
                //                     file: 'https://apigwd.scg.com/DebentureClubDev/files/activity/ticket/doc/wiUfs1652170652.jpg',
                //                 },
                //             ],
                //             condition: '<p>ทดสอบเงื่อนไขกลุ่ม 1</p>',
                //         },
                //     ],
                // },
            },
            columns_data: [],
        };
    },
    computed: {
        columns() {
            const columns = [];
            const mid = Math.ceil(this.items.length / 2);
            for (let col = 0; col < 2; col++) {
                columns.push(this.items.slice(col * mid, col * mid + mid));
            }
            return columns;
        },
    },
    mounted() {
        this._mounted();
    },
    methods: {
        moment,
        _mounted: function () {
            this.getActivityDetail(() => (this.getting_data = false));
        },
        getActivityDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/activity/detail',
                    data: {
                        apply_id: this.apply_id,
                    },
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const error = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                console.log('value', value);
                                if (key) {
                                    error.title = value[0];
                                }
                            }
                            this.$confirm({
                                title: error.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        } else {
                            this.ticket_data = res;
                            console.log('this.ticket_data--------------->', this.ticket_data);
                            const doc_list = this.ticket_data.ticket_data.doc_list;
                            const sorted1 = [];
                            const sorted2 = [];
                            _.each(doc_list, (v1, k1) => {
                                if (k1 % 2 == 0) sorted1.push(v1);
                                else sorted2.push(v1);
                            });
                            this.items = _.clone([...sorted1, ...sorted2]);
                            // this.columns_data[0] = [];
                            // this.columns_data[1] = [];
                            // while (arr.length) {
                            //     this.columns_data[0].push(arr.splice(0, 1)[0]);
                            //     this.columns_data[1].push(arr.splice(0, 1)[0]);
                            // }
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        handlePageChange(page) {
            console.log('handlePageChange page -->', page);
        },
        goToDocDetail(doc) {
            this.$router.replace({
                path: '/doc-info',
                query: {
                    apply_id: this.apply_id,
                    label: doc.label,
                    pdf_url: doc.pdf_url,
                    back_path: `/doc-list?apply_id=${this.apply_id}&back_path=${this.back_path}`,
                },
            });
        },
        toMoment(date_unix, format) {
            return this.mtby(moment.unix(date_unix), format);
        },
        size(v) {
            return _.size(v);
        },
        get(v1, v2, v3) {
            return _.get(v1, v2, v3);
        },
    },
};
</script>
<style scoped>
.main-content {
    /* background-color: red; */
    width: 100vw;
    /* padding: 14px; */
    min-height: 100vh;
}
.main-content.is-tablet.step-register_success {
    margin-top: 15vh;
}
.badge-icon {
    position: absolute;
    top: 3px;
    right: 200px;
    background: url('../../../public/resources/images/follower-badge.png');
    background-size: 100%;
    width: 40px;
    height: 40px;
}
.badge-icon-new {
    top: 3px;
    right: 200px;
    background: url('../../../public/resources/images/follower-badge.png');
    background-size: 100%;
    width: 40px;
    height: 40px;
    margin: 4px;
}
.badge-label {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    color: #000 !important;
    line-height: 40px;
    font-size: 14px;
}
.custom-card {
    margin: 16px;
    background-color: #fff;
    border-radius: 8px;
}
.custom-close {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
    padding-top: 48px;
}
.VueCarousel {
    margin-top: -10px !important;
}
.title {
    font-size: 20px;
    font-weight: 600;
    margin: 8px 0 0 16px;
    color: #cc0000 !important;
}
.description {
    font-size: 16px;
    font-weight: 300;
    margin: 0 16px;
    color: #000 !important;
}
.description-read-all {
    font-size: 16px;
    font-weight: 300;
    margin: 0 16px;
    color: #000 !important;
}
.read-all {
    font-size: 14px;
    font-weight: 300;
    margin: 8px 0 8px 0;
    color: #707070 !important;
}
.half-circle {
    width: 50px;
    height: 25px; /* as the half of the width */
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    /* border: 10px solid gray; */
    border-top: 0;
    box-shadow: #707070 0px 25px 40px 0px;
    margin: 0 auto;
}
/* .vue-confirm-dialog {
}
.vue-confirm-dialog .vc-container .vc-text-grid .vc-title {
  font-size: 16px !important;
}
.vc-title {
  font-size: 16px !important;
} */
.กางได้ {
    width: 90%;
    min-height: 64px;
    line-height: 64px;
    background: linear-gradient(0deg, #af2e30, #e05a61 100%) no-repeat;
    margin: 8px auto;
    color: #fff;
    font-weight: 300;
    padding: 0 16px;
}
/* .custom-container {
    display: flex;
    min-height: 100vh;
}
.col {
    margin: 10px;
    border: 1px solid;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.custom-container-item {
    padding: 14px;
    margin: 14px;
    text-align: center;
    border-radius: 14px;
} */
.custom-container {
    /* border: 1px solid; */
    display: flex;
}
.custom-col {
    /* border: 1px solid; */
    margin: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.custom-item-container {
    /* border: 1px solid; */
    padding: 14px;
    margin: 14px;
    /* height: 100%; */
    text-align: center;
    border-radius: 20px;
    /* box-shadow: 1px 1px #808080; */
}
</style>
